import { useQuery } from '@tanstack/react-query';
import { useOrgStore } from '@/stores/org-store';
import { listAgents } from '@/services/agents/config';
import type { Agent } from '@/types/agent-types';

export const agentsQueryKey = (orgId?: string) => ['agents', orgId] as const;

export const useListAgents = () => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<Agent[], Error>({
    queryKey: agentsQueryKey(orgId),
    queryFn: () => listAgents(orgId!),
    enabled: !!orgId,
    staleTime: 30_000,
    retry: 1,
  });
};
